<template>    
  <div
    class="results-table__cell"
    :title="cellValue"
  >
    <router-link :to="currentRoute">
      {{ cellValue }}
    </router-link>
  </div>
</template>

<script>
import { cellMixins } from './mixins'

export default {
  mixins: [cellMixins],

  computed: {
    cellValue() {
      return this.docData[this.cellData.dataFields[0]]
    },
    currentRoute() {
      return {
        name: 'document',
        params: {
          id: this.docData.id
        }
      }
    }
  }
};
</script>
